import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_featured_all: FaireCategoryEntity = {
  token: "cat_featured-all",
  type: "category",
  name: "All featured brands",
  level: 2,
  parentToken: "cat_featured-brands",
  href: "/category/featured-brands",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
